module.exports = __webpack_public_path__ + "static/media/43-10.1882ba65.mp3";